//import { ConfigTopNode } from '@/types'
export default {

  parseContainerEntry(
    entry : any,
    container: Object,
    idCounter : number,
    nodeCounters : Object,
    configNodesMap: Object,
    topLevelNodeNameReferenceIDsMap: Object,
    ){

    let nestedContainerObject: Object = {
      id: ++idCounter,
      name: entry[1],
      type: entry[0],
      parentNodeId: container['id'],
      rootNodeId: -1, //for the leaf nodes, rootNodeId will be calculated with references
      ctype: '', //only should be valid for modules but lets leave it this way for others
    }
    nodeCounters[entry[0]]++

    configNodesMap[idCounter] = nestedContainerObject
    container['children'].push(nestedContainerObject)

    if (
      topLevelNodeNameReferenceIDsMap[nestedContainerObject['name']] ==
      undefined
    ) {
      topLevelNodeNameReferenceIDsMap[
        nestedContainerObject['name']
      ] = new Set()
    }
    topLevelNodeNameReferenceIDsMap[nestedContainerObject['name']].add(
      nestedContainerObject['id']
    )
  },
  parseContainerType(
    containerData: any,
    configNodesMap: Object,
    topLevelNodeNameToIdMap: Object,
    topLevelNodeTypeToIdMap: Object,
    topLevelNodeNameReferenceIDsMap: Object,
    idCounter: number,
    nodeCounters: Object,
    name: string,
    type: string,
    jsonKey: string,
    nodeKey: string, 
    containerIdName: string
  ): Object {
    let containersObject: Object = {
      id: ++idCounter,
      name: name,
      type: type,
      children: [],
      parentNodeId: 0,
      rootNodeId: idCounter,
    }
  
    topLevelNodeTypeToIdMap[nodeKey] = []

    for (const [key, value] of Object.entries(containerData)) {  
      let containerObject: Object = {
        id: ++idCounter,
        name: key,
        type: jsonKey,
        children: [],
        parentNodeId: containersObject['id'],
        rootNodeId: idCounter, //for the root nodes, rootNodeId = itself
      }
      nodeCounters[nodeKey]++

      topLevelNodeNameToIdMap[containerObject['name']] = containerObject['id']
      topLevelNodeTypeToIdMap[nodeKey].push(containerObject['id'])

      // eslint-disable-next-line no-unused-vars
      for (const [key1, value1] of Object.entries(Object(value))) {
        //loop over container's entries
        this.parseContainerEntry(
            Object(value1),containerObject,
            idCounter,
            nodeCounters,
            configNodesMap,
            topLevelNodeNameReferenceIDsMap
        )
      }
      configNodesMap[containerObject['id']] = containerObject

      containersObject['children'].push(containerObject)
    }
    configNodesMap[containersObject['id']] = containersObject
    return { [containerIdName]: containersObject['id'], idCounter: idCounter }
  },
  

  buildRecursiveVPSetObject(
    vpSetObject: Object,
    body: any,
    parentID: number,
    configNodesMap: Object,
    idCounter: number,
    nodeCounters: Object
  ): number {
    //console.log(JSON.stringify(vpSetObject))
    //console.log(body)
    //console.log('PARENT ID: ' + parentID)
    //if the body has more then 0 keys it is an unnamed nested PSet
    //if (Object.entries(Object(body)).length > 1) {
    //console.log('NESTED UNNAMED PSET')
    //}
    // eslint-disable-next-line no-unused-vars
    for (const [key, value] of Object.entries(Object(body))) {
      //if (vpSetObject['name'] === 'qualityTests') {
      //console.log('LOOPING 1')
      //console.log('key: ' + key)
      //}
      //loop over VPSet entries
      //if (vpSetObject['name'] === 'regressionConfig') {
      //console.log(JSON.stringify(key))
      //console.log(JSON.stringify(value))
      //console.log('key: ' + key)
      //console.log('value: ' + value)
      //}
      let nestedNoNamePSetObject: Object = {} //might or might not be used
      //let nestedNoNamePSetObjectId = 0
      if (Object.entries(Object(body)).length > 1) {
        nestedNoNamePSetObject['id'] = ++idCounter
        nestedNoNamePSetObject['name'] = 'PSet' //no name
        nestedNoNamePSetObject['type'] == 'PSet'
        nestedNoNamePSetObject['children'] = []
        nestedNoNamePSetObject['parentNodeId'] = parentID
        nestedNoNamePSetObject['paremeterJSONValue'] = Infinity
      }

      //console.log(JSON.stringify(key), JSON.stringify(value))
      // eslint-disable-next-line no-unused-vars
      for (const [key1, value1] of Object.entries(Object(value))) {
        let nestedVPSetObject: Object = {}
        nestedVPSetObject['id'] = ++idCounter

        //this is parameter loop
        //if (vpSetObject['name'] === 'regressionConfig') {
        //console.log(JSON.stringify(key1), JSON.stringify(value1))
        //}
        for (const [key2, value2] of Object.entries(Object(value1))) {
          //if (vpSetObject['name'] === 'regressionConfig') {
          //console.log(JSON.stringify(key2), JSON.stringify(value2))
          //}
          if (key2 === 'type') nestedVPSetObject['type'] = value2 as string
          else if (key2 === 'value') {
            if (
              nestedVPSetObject['type'] == 'cms.VPSet' ||
              nestedVPSetObject['type'] == 'cms.PSet' ||
              nestedVPSetObject['type'] == 'cms.untracked.PSet' ||
              nestedVPSetObject['type'] == 'cms.untracked.VPSet'
            ) {
              //if (vpSetObject['name'] === 'regressionConfig') {
              //console.log('type PSET')
              //}
              nestedVPSetObject['name'] = key1
              //if (key1 === 'qualityTests') {
              //console.log('AAAAA')
              //console.log('value2: ' + JSON.stringify(value2))
              //}

              /*     if (nestedVPSetObject['type'] == 'cms.VPSet')
                nestedVPSetObject['name'] = 'VPSet'
              else nestedVPSetObject['name'] = 'PSet' */

              nestedVPSetObject['children'] = []
              idCounter = this.buildRecursiveVPSetObject(
                nestedVPSetObject,
                value2,
                nestedVPSetObject['id'],
                configNodesMap,
                idCounter,
                nodeCounters
              ) //TODO: is parent ID ok?
            } else {
              nestedVPSetObject['name'] = key1 + ' = '
              nestedVPSetObject['children'] = []

              //if (vpSetObject['name'] === 'regressionConfig') {
              //console.log('type ' + nestedVPSetObject['type'])
              //}
              nestedVPSetObject['paremeterJSONValue'] = value2
            }
          }
          //if (vpSetObject['name'] === 'regressionConfig') {
          //console.log(JSON.stringify(nestedVPSetObject))
          //}
        }
        if (nestedVPSetObject['type'] != undefined) {
          let cmsTypeLenght = nestedVPSetObject['type'].length
          let cmsType = nestedVPSetObject['type'].substring(
            //cmsType is necessary for printing out in tree
            nestedVPSetObject['type'].indexOf('.') + 1,
            cmsTypeLenght
          )
          nestedVPSetObject['cmsType'] = cmsType
        }
        /*    console.log(
          'NESTED MODULE OBJECT: ' + JSON.stringify(nestedModuleObject)
        ) */
        //console.log('NESTED MODULE TYPE ' + nestedModuleObject['type'])

        //if (vpSetObject['name'] === 'regressionConfig') {
        //console.log(nestedVPSetObject)
        //}

        nestedVPSetObject['parentNodeId'] = -1 //TODO: who's parent?

        configNodesMap[nestedVPSetObject['id']] = nestedVPSetObject

        if (Object.entries(Object(body)).length == 1) {
          nestedVPSetObject['parentNodeId'] = vpSetObject['id']
          vpSetObject['children'].push(nestedVPSetObject)
        } else {
          nestedVPSetObject['parentNodeId'] = nestedNoNamePSetObject['id']
          nestedNoNamePSetObject['children'].push(nestedVPSetObject)
        }
      }

      configNodesMap[nestedNoNamePSetObject['id']] = nestedNoNamePSetObject

      if (Object.entries(Object(body)).length > 1) {
        vpSetObject['children'].push(nestedNoNamePSetObject)
      }
    }

    return idCounter
  },

  parseModules(
    moduleData: any,
    configNodesMap: Object,
    topLevelNodeNameToIdMap: Object,
    topLevelNodeTypeToIdMap: Object,
    topLevelNodeNameReferenceIDsMap: Object,
    topLevelModuleNameToChildrenIDsMap: Object,
    idCounter: number,
    nodeCounters: Object
  ) {
    let modulesObject: Object = {
      id: ++idCounter,
      name: 'Modules',
      type: 'mods',
      children: [],
      parentNodeId: 0,
      rootNodeId: idCounter,
    }

    //topLevelNodeNameToIdMap['modules'] = modulesObject['id']
    topLevelNodeTypeToIdMap['modules'] = []

    for (const [key, value] of Object.entries(moduleData)) {
      //loop over modules - create new Module object and add it to children of the mods
      //console.log('NAME: ' + key)
      let moduleObject: Object = {
        id: ++idCounter,
        name: key,
        type: 'modules',
        parentNodeId: modulesObject['id'],
        rootNodeId: idCounter, //for the root nodes, rootNodeId = itself
        ctype: '',
      }
      nodeCounters['modules']++

      topLevelNodeNameToIdMap[moduleObject['name']] = moduleObject['id']
      topLevelNodeTypeToIdMap['modules'].push(moduleObject['id'])

      //console.log(`${key}`)
      // eslint-disable-next-line no-unused-vars
      for (const [key1, value1] of Object.entries(Object(value))) {
        //loop over module entries
        //console.log(`${key1}`)
        if (key1 === 'params') {
          // eslint-disable-next-line no-unused-vars
          for (const [key2, value2] of Object.entries(Object(value1))) {
            //console.log(key2)

            let nestedParameterObject: Object = {}
            nestedParameterObject['id'] = ++idCounter
            nestedParameterObject['children'] = []

            for (const [key3, value3] of Object.entries(Object(value2))) {
              if (key3 === 'type')
                nestedParameterObject['type'] = value3 as string
              else if (key3 === 'value') {
                if (
                  nestedParameterObject['type'] == 'cms.VPSet' ||
                  nestedParameterObject['type'] == 'cms.PSet' ||
                  nestedParameterObject['type'] == 'cms.untracked.PSet' ||
                  nestedParameterObject['type'] == 'cms.untracked.VPSet'
                ) {
                  nestedParameterObject['children'] = []
                  nestedParameterObject['name'] = key2

                  idCounter = this.buildRecursiveVPSetObject(
                    nestedParameterObject,
                    value3,
                    moduleObject['id'],
                    configNodesMap,
                    idCounter,
                    nodeCounters
                  )
                } else {
                  nestedParameterObject['name'] = key2 + ' = '
                  //simple type
                  nestedParameterObject['paremeterJSONValue'] = value3
                }
              }
              //console.log(key3)
            }
            if (nestedParameterObject['type'] != undefined) {
              let cmsTypeLenght = nestedParameterObject['type'].length
              let cmsType = nestedParameterObject['type'].substring(
                //cmsType is necessary for printing out in tree
                nestedParameterObject['type'].indexOf('.') + 1,
                cmsTypeLenght
              )
              nestedParameterObject['cmsType'] = cmsType
              //console.log(nestedParameterObject)
            }
            nestedParameterObject['parentNodeId'] = moduleObject['id']

            configNodesMap[nestedParameterObject['id']] = nestedParameterObject

            //push parameter into module children
            //moduleObject['children'].push(nestedParameterObject)
            if (
              topLevelModuleNameToChildrenIDsMap[moduleObject['name']] ==
              undefined
            )
              topLevelModuleNameToChildrenIDsMap[
                moduleObject['name']
              ] = new Set()
            topLevelModuleNameToChildrenIDsMap[moduleObject['name']].add(
              nestedParameterObject['id']
            )
          }
        } else if (key1 === 'ctype') {
          moduleObject['ctype'] = value1 as string
        } else if (key1 === 'pytype') {
          moduleObject['pytype'] = value1
        }
      }
      modulesObject['children'].push(moduleObject)

      //TODO: fix handling of modules that have no references in loaded JSON
      if (topLevelNodeNameReferenceIDsMap[moduleObject['name']] == undefined)
        //this is probably uncecessary
        topLevelNodeNameReferenceIDsMap[moduleObject['name']] = new Set()

      configNodesMap[moduleObject['id']] = moduleObject
    }

    configNodesMap[modulesObject['id']] = modulesObject

    return { modulesId: modulesObject['id'], idCounter: idCounter }
  },

  parseSwitchProducers(
    switchProducerData: any,
    configNodesMap: Object,
    topLevelNodeNameToIdMap: Object,
    topLevelNodeTypeToIdMap: Object,
    topLevelNodeNameReferenceIDsMap: Object,
    idCounter: number,
    nodeCounters: Object
  ) {
    let switchProducersObject: Object = {
      id: ++idCounter,
      name: 'Switch Producers',
      type: 'switchprods',
      children: [],
      parentNodeId: 0,
      rootNodeId: idCounter,
    }

    //topLevelNodeNameToIdMap['switchprods'] = switchProducersObject['id']
    topLevelNodeTypeToIdMap['switchprods'] = []

    for (const [key, value] of Object.entries(switchProducerData)) {
      //loop over switch producers - create new SP object and add it to children of the switchprods
      //console.log('NAME: ' + key)
      let switchProducerObject: Object = {
        id: ++idCounter,
        name: key,
        type: 'switchproducers',
        children: [],
        parentNodeId: switchProducersObject['id'],
        rootNodeId: idCounter, //for the root nodes, rootNodeId = itself
      }

      topLevelNodeNameToIdMap[switchProducerObject['name']] =
        switchProducerObject['id']
      topLevelNodeTypeToIdMap['switchprods'].push(switchProducerObject['id'])

      //console.log(`${key}`)
      // eslint-disable-next-line no-unused-vars
      for (const [key1, value1] of Object.entries(Object(value))) {
        //loop over switchproducer entries
        //console.log(`${key1}`)
        if (key1 === 'params') {
          // eslint-disable-next-line no-unused-vars
          for (const [key2, value2] of Object.entries(Object(value1))) {
            //console.log(key2)
            //console.log(value2)
            let cpuGpuObject: Object = {
              id: ++idCounter,
              name: key2,
              type: 'cpuGpu',
              children: [],
              parentNodeId: switchProducerObject['id'],
              rootNodeId: idCounter, //for the root nodes, rootNodeId = itself
            }

            let cpuGpuJSON = value2 as Object
            let cpuGpuNestedObjectName = '' as string
            let cpuGpuNestedObjectIcon = '' as string

            if (cpuGpuJSON['pytype'] == 'EDAlias') {
              cpuGpuNestedObjectName = cpuGpuJSON['pytype']
              cpuGpuNestedObjectIcon = 'edalias'
            } else {
              cpuGpuNestedObjectName = cpuGpuJSON['ctype']
              cpuGpuNestedObjectIcon = 'module'
            }

            let cpuGpuNestedObject: Object = {
              id: ++idCounter,
              name: cpuGpuNestedObjectName,
              type: 'cpuGpuNested',
              iconType: cpuGpuNestedObjectIcon,
              children: [],
              parentNodeId: cpuGpuObject['id'],
              rootNodeId: idCounter, //for the root nodes, rootNodeId = itself
              pytype: cpuGpuJSON['pytype'],
              ctype: cpuGpuJSON['ctype'],
            }

            /*       console.log(
              'cpuGpuNestedObject:' + JSON.stringify(cpuGpuNestedObject)
            ) */

            for (const [key3, value3] of Object.entries(
              Object(cpuGpuJSON['params'])
            )) {
              let nestedParameterObject: Object = {}
              nestedParameterObject['id'] = ++idCounter
              nestedParameterObject['children'] = []

              //console.log('KEY: ' + key3)
              //console.log('VALUE: ' + value3)
              let paramObject = value3 as Object
              nestedParameterObject['type'] = paramObject['type']
              if (
                nestedParameterObject['type'] == 'cms.VPSet' ||
                nestedParameterObject['type'] == 'cms.PSet' ||
                nestedParameterObject['type'] == 'cms.untracked.PSet' ||
                nestedParameterObject['type'] == 'cms.untracked.VPSet'
              ) {
                nestedParameterObject['name'] = key3

                idCounter = this.buildRecursiveVPSetObject(
                  nestedParameterObject,
                  paramObject['value'],
                  cpuGpuNestedObject['id'],
                  configNodesMap,
                  idCounter,
                  nodeCounters
                )
              } else {
                nestedParameterObject['name'] = key3 + ' = '
                //simple type
                let value3Obj = value3 as Object
                nestedParameterObject['paremeterJSONValue'] = value3Obj['value']
                //console.log('JSON: ' + JSON.stringify(value3))
              }
              if (nestedParameterObject['type'] != undefined) {
                let cmsTypeLenght = nestedParameterObject['type'].length
                let cmsType = nestedParameterObject['type'].substring(
                  //cmsType is necessary for printing out in tree
                  nestedParameterObject['type'].indexOf('.') + 1,
                  cmsTypeLenght
                )
                nestedParameterObject['cmsType'] = cmsType
                //console.log(nestedParameterObject)
              }
              nestedParameterObject['parentNodeId'] = cpuGpuNestedObject['id']
              nestedParameterObject['rootNodeId'] = -1 //TODO: can this be referenced at all?

              configNodesMap[
                nestedParameterObject['id']
              ] = nestedParameterObject
              //console.log(key3)
              cpuGpuNestedObject['children'].push(nestedParameterObject)
            }

            configNodesMap[cpuGpuNestedObject['id']] = cpuGpuNestedObject
            configNodesMap[cpuGpuObject['id']] = cpuGpuObject

            //console.log('NESTED:' + JSON.stringify(nestedParameterObject))
            //push parameter into switchproducer children
            cpuGpuObject['children'].push(cpuGpuNestedObject)
            switchProducerObject['children'].push(cpuGpuObject)
          }
        } else if (key1 === 'ctype') {
          switchProducerObject['ctype'] = value1 as string
        } else if (key1 === 'pytype') {
          switchProducerObject['pytype'] = value1
        }
      }
      switchProducersObject['children'].push(switchProducerObject)

      //TODO: fix handling of modules that have no references in loaded JSON
      if (
        topLevelNodeNameReferenceIDsMap[switchProducerObject['name']] ==
        undefined
      )
        topLevelNodeNameReferenceIDsMap[
          switchProducerObject['name']
        ] = new Set()

      configNodesMap[switchProducerObject['id']] = switchProducerObject
    }

    configNodesMap[switchProducersObject['id']] = switchProducersObject

    return {
      switchProducersId: switchProducersObject['id'],
      idCounter: idCounter,
    }
  },

  parsePSets(
    psetData: any,
    configNodesMap: Object,
    topLevelNodeNameToIdMap: Object,
    topLevelNodeTypeToIdMap: Object,
    topLevelNodeNameReferenceIDsMap: Object,
    idCounter: number,
    nodeCounters: Object
  ) {
    //console.log(psetData)
    let psetsObject: Object = {
      id: ++idCounter,
      name: 'PSets',
      type: 'psets',
      children: [],
      parentNodeId: 0,
      rootNodeId: idCounter,
    }
    //topLevelNodeNameToIdMap['psets'] = psetsObject['id']
    topLevelNodeTypeToIdMap['psets'] = []

    //let psetsIdCounter = this.idCounter

    for (const [key, value] of Object.entries(psetData)) {
      //loop over psets - create new PSet object and add it to children of the psets
      //console.log('NAME: ' + key)
      //exclude datasets and streams from the PSets
      if (key == 'datasets' || key == 'streams') continue
      let psetObject: Object = {
        id: ++idCounter,
        name: key,
        type: 'pset',
        children: [],
        parentNodeId: psetsObject['id'],
        rootNodeId: idCounter,
      }
      topLevelNodeNameToIdMap[psetObject['name']] = psetObject['id']
      topLevelNodeTypeToIdMap['psets'].push(psetObject['id'])
      //let psetIdCounter = this.idCounter

      //console.log(`${key}`)
      // eslint-disable-next-line no-unused-vars
      for (const [key1, value1] of Object.entries(Object(value))) {
        //loop over pset entries
        //if (key == 'HLTPSetPixelLessStepTrajectoryFilter') {
        //console.log(`${key1}, ${value1}`)
        //}
        let nestedPSetObject: Object = {}
        nestedPSetObject['id'] = ++idCounter
        //console.log(`${key1}, ${value1}`)
        //if (key1 === 'para_name') {
        // eslint-disable-next-line no-unused-vars
        for (const [key2, value2] of Object.entries(Object(value1))) {
          //aviod para_name level
          //console.log('ANYTHING')
          //console.log(`${key2}, ${value2}`)
          if (key2 === 'type') nestedPSetObject['type'] = value2 as string
          else if (key2 === 'value') {
            if (
              nestedPSetObject['type'] == 'cms.VPSet' ||
              nestedPSetObject['type'] == 'cms.PSet' ||
              nestedPSetObject['type'] == 'cms.untracked.PSet' ||
              nestedPSetObject['type'] == 'cms.untracked.VPSet'
            ) {
              nestedPSetObject['name'] = key1
              nestedPSetObject['children'] = []

              idCounter = this.buildRecursiveVPSetObject(
                nestedPSetObject,
                value2,
                psetObject['id'],
                configNodesMap,
                idCounter,
                nodeCounters
              )
            } else {
              nestedPSetObject['paremeterJSONValue'] = value2
              nestedPSetObject['children'] = []
              nestedPSetObject['name'] = key1 + ' = '
            }
          }
          //console.log(key3)
        }
        //}
        /*    console.log(
          'NESTED MODULE OBJECT: ' + JSON.stringify(nestedModuleObject)
        ) */
        //console.log('NESTED MODULE TYPE ' + nestedModuleObject['type'])
        if (nestedPSetObject['type'] != undefined) {
          let cmsTypeLenght = nestedPSetObject['type'].length
          let cmsType = nestedPSetObject['type'].substring(
            //cmsType is necessary for printing out in tree
            nestedPSetObject['type'].indexOf('.') + 1,
            cmsTypeLenght
          )
          nestedPSetObject['cmsType'] = cmsType
          nestedPSetObject['parentNodeId'] = psetObject['id'] //TODO: who's parent?

          configNodesMap[nestedPSetObject['id']] = nestedPSetObject
          psetObject['children'].push(nestedPSetObject)
        }
      }
      psetsObject['children'].push(psetObject)

      configNodesMap[psetObject['id']] = psetObject
    }
    configNodesMap[psetsObject['id']] = psetsObject

    return { psetsId: psetsObject['id'], idCounter: idCounter }
  },

  parseESProducers(
    esProducerData: any,
    configNodesMap: Object,
    topLevelNodeNameToIdMap: Object,
    topLevelNodeTypeToIdMap: Object,
    topLevelNodeNameReferenceIDsMap: Object,
    idCounter: number,
    nodeCounters: Object
  ) {
    let esProducersObject: Object = {
      id: ++idCounter,
      name: 'ESProducers',
      type: 'esprods',
      children: [],
      parentNodeId: 0,
      rootNodeId: idCounter,
    }
    //topLevelNodeNameToIdMap['esproducers'] = esProducersObject['id']
    topLevelNodeTypeToIdMap['esproducers'] = []

    for (const [key, value] of Object.entries(esProducerData)) {
      //loop over esproducers - create new esproducer object and add it to children of the esprods
      //console.log('NAME: ' + key)
      let esProducerObject: Object = {
        id: ++idCounter,
        name: key,
        type: 'esproducers',
        children: [],
        parentNodeId: esProducersObject['id'],
        rootNodeId: idCounter, //for the root nodes, rootNodeId = itself
        ctype: '',
      }
      topLevelNodeNameToIdMap[esProducerObject['name']] = esProducerObject['id']
      topLevelNodeTypeToIdMap['esproducers'].push(esProducerObject['id'])

      //console.log(`${key}`)
      // eslint-disable-next-line no-unused-vars
      for (const [key1, value1] of Object.entries(Object(value))) {
        //loop over esproducer entries
        //console.log(`${key1}`)
        if (key1 === 'params') {
          // eslint-disable-next-line no-unused-vars
          for (const [key2, value2] of Object.entries(Object(value1))) {
            //console.log(key2)

            let nestedParameterObject: Object = {}
            nestedParameterObject['id'] = ++idCounter
            nestedParameterObject['children'] = []

            for (const [key3, value3] of Object.entries(Object(value2))) {
              if (key3 === 'type')
                nestedParameterObject['type'] = value3 as string
              else if (key3 === 'value') {
                if (
                  nestedParameterObject['type'] == 'cms.VPSet' ||
                  nestedParameterObject['type'] == 'cms.PSet' ||
                  nestedParameterObject['type'] == 'cms.untracked.PSet' ||
                  nestedParameterObject['type'] == 'cms.untracked.VPSet'
                ) {
                  nestedParameterObject['children'] = []
                  nestedParameterObject['name'] = key2

                  idCounter = this.buildRecursiveVPSetObject(
                    nestedParameterObject,
                    value3,
                    esProducerObject['id'],
                    configNodesMap,
                    idCounter,
                    nodeCounters
                  )
                } else {
                  nestedParameterObject['name'] = key2 + ' = '
                  //simple type
                  nestedParameterObject['paremeterJSONValue'] = value3
                }
              }
              //console.log(key3)
            }
            if (nestedParameterObject['type'] != undefined) {
              let cmsTypeLenght = nestedParameterObject['type'].length
              let cmsType = nestedParameterObject['type'].substring(
                //cmsType is necessary for printing out in tree
                nestedParameterObject['type'].indexOf('.') + 1,
                cmsTypeLenght
              )
              nestedParameterObject['cmsType'] = cmsType
              //console.log(nestedParameterObject)
            }
            nestedParameterObject['parentNodeId'] = esProducerObject['id']
            nestedParameterObject['rootNodeId'] = -1 //TODO: can this be referenced at all?

            configNodesMap[nestedParameterObject['id']] = nestedParameterObject

            //push parameter into module children
            esProducerObject['children'].push(nestedParameterObject)
          }
        } else if (key1 === 'ctype') {
          esProducerObject['ctype'] = value1 as string
        } else if (key1 === 'pytype') {
          esProducerObject['pytype'] = value1
        }
      }
      esProducersObject['children'].push(esProducerObject)

      configNodesMap[esProducerObject['id']] = esProducerObject
    }

    configNodesMap[esProducersObject['id']] = esProducersObject

    return { esProducersId: esProducersObject['id'], idCounter: idCounter }
  },

  parseESSources(
    esSourceData: any,
    configNodesMap: Object,
    topLevelNodeNameToIdMap: Object,
    topLevelNodeTypeToIdMap: Object,
    topLevelNodeNameReferenceIDsMap: Object,
    idCounter: number,
    nodeCounters: Object
  ) {
    let esSourcesObject: Object = {
      id: ++idCounter,
      name: 'ESSources',
      type: 'essour',
      children: [],
      parentNodeId: 0,
      rootNodeId: idCounter,
    }
    //topLevelNodeNameToIdMap['essources'] = esSourcesObject['id']
    topLevelNodeTypeToIdMap['essources'] = []

    for (const [key, value] of Object.entries(esSourceData)) {
      //loop over essources - create new essource object and add it to children of the essources
      //console.log('NAME: ' + key)
      let esSourceObject: Object = {
        id: ++idCounter,
        name: key,
        type: 'essources',
        children: [],
        parentNodeId: esSourcesObject['id'],
        rootNodeId: idCounter, //for the root nodes, rootNodeId = itself
        ctype: '',
      }
      topLevelNodeNameToIdMap[esSourceObject['name']] = esSourceObject['id']
      topLevelNodeTypeToIdMap['essources'].push(esSourceObject['id'])

      //console.log(`${key}`)
      // eslint-disable-next-line no-unused-vars
      for (const [key1, value1] of Object.entries(Object(value))) {
        //loop over essource entries
        //console.log(`${key1}`)
        if (key1 === 'params') {
          // eslint-disable-next-line no-unused-vars
          for (const [key2, value2] of Object.entries(Object(value1))) {
            //console.log(key2)

            let nestedParameterObject: Object = {}
            nestedParameterObject['id'] = ++idCounter
            nestedParameterObject['children'] = []

            for (const [key3, value3] of Object.entries(Object(value2))) {
              if (key3 === 'type')
                nestedParameterObject['type'] = value3 as string
              else if (key3 === 'value') {
                if (
                  nestedParameterObject['type'] == 'cms.VPSet' ||
                  nestedParameterObject['type'] == 'cms.PSet' ||
                  nestedParameterObject['type'] == 'cms.untracked.PSet' ||
                  nestedParameterObject['type'] == 'cms.untracked.VPSet'
                ) {
                  nestedParameterObject['children'] = []
                  nestedParameterObject['name'] = key2

                  idCounter = this.buildRecursiveVPSetObject(
                    nestedParameterObject,
                    value3,
                    esSourceObject['id'],
                    configNodesMap,
                    idCounter,
                    nodeCounters
                  )
                } else {
                  nestedParameterObject['name'] = key2 + ' = '
                  //simple type
                  nestedParameterObject['paremeterJSONValue'] = value3
                }
              }
              //console.log(key3)
            }
            if (nestedParameterObject['type'] != undefined) {
              let cmsTypeLenght = nestedParameterObject['type'].length
              let cmsType = nestedParameterObject['type'].substring(
                //cmsType is necessary for printing out in tree
                nestedParameterObject['type'].indexOf('.') + 1,
                cmsTypeLenght
              )
              nestedParameterObject['cmsType'] = cmsType
              //console.log(nestedParameterObject)
            }
            nestedParameterObject['parentNodeId'] = esSourceObject['id']
            nestedParameterObject['rootNodeId'] = -1 //TODO: can this be referenced at all?

            configNodesMap[nestedParameterObject['id']] = nestedParameterObject

            //push parameter into module children
            esSourceObject['children'].push(nestedParameterObject)
          }
        } else if (key1 === 'ctype') {
          esSourceObject['ctype'] = value1 as string
        } else if (key1 === 'pytype') {
          esSourceObject['pytype'] = value1
        }
      }
      esSourcesObject['children'].push(esSourceObject)

      configNodesMap[esSourceObject['id']] = esSourceObject
    }

    configNodesMap[esSourcesObject['id']] = esSourcesObject

    return { esSourcesId: esSourcesObject['id'], idCounter: idCounter }
  },

  parseServices(
    serviceData: any,
    configNodesMap: Object,
    topLevelNodeNameToIdMap: Object,
    topLevelNodeTypeToIdMap: Object,
    topLevelNodeNameReferenceIDsMap: Object,
    idCounter: number,
    nodeCounters: Object
  ) {
    let servicesObject: Object = {
      id: ++idCounter,
      name: 'Services',
      type: 'serv', //TODO: fix JSON -> node type naming conventions
      children: [],
      parentNodeId: 0,
      rootNodeId: idCounter,
    }
    //topLevelNodeNameToIdMap['services'] = servicesObject['id']
    topLevelNodeTypeToIdMap['services'] = []

    for (const [key, value] of Object.entries(serviceData)) {
      //loop over services - create new service object and add it to children of the seqs
      //console.log('NAME: ' + key)
      let serviceObject: Object = {
        id: ++idCounter,
        name: key,
        type: 'services',
        children: [],
        childrenIds: [],
        parentNodeId: servicesObject['id'],
        rootNodeId: idCounter, //for the root nodes, rootNodeId = itself
        ctype: '',
      }
      topLevelNodeNameToIdMap[serviceObject['name']] = serviceObject['id']
      topLevelNodeTypeToIdMap['services'].push(serviceObject['id'])

      //console.log(`${key}`)
      // eslint-disable-next-line no-unused-vars
      for (const [key1, value1] of Object.entries(Object(value))) {
        //loop over service entries
        //console.log(`${key1}`)
        if (key1 === 'params') {
          // eslint-disable-next-line no-unused-vars
          for (const [key2, value2] of Object.entries(Object(value1))) {
            //console.log(key2)

            let nestedParameterObject: Object = {}
            nestedParameterObject['id'] = ++idCounter
            nestedParameterObject['children'] = []

            for (const [key3, value3] of Object.entries(Object(value2))) {
              if (key3 === 'type')
                nestedParameterObject['type'] = value3 as string
              else if (key3 === 'value') {
                if (
                  nestedParameterObject['type'] == 'cms.VPSet' ||
                  nestedParameterObject['type'] == 'cms.PSet' ||
                  nestedParameterObject['type'] == 'cms.untracked.PSet' ||
                  nestedParameterObject['type'] == 'cms.untracked.VPSet'
                ) {
                  nestedParameterObject['children'] = []
                  nestedParameterObject['name'] = key2

                  idCounter = this.buildRecursiveVPSetObject(
                    nestedParameterObject,
                    value3,
                    serviceObject['id'],
                    configNodesMap,
                    idCounter,
                    nodeCounters
                  )
                } else {
                  nestedParameterObject['name'] = key2 + ' = '
                  //simple type
                  nestedParameterObject['paremeterJSONValue'] = value3
                }
              }
              //console.log(key3)
            }
            if (nestedParameterObject['type'] != undefined) {
              let cmsTypeLenght = nestedParameterObject['type'].length
              let cmsType = nestedParameterObject['type'].substring(
                //cmsType is necessary for printing out in tree
                nestedParameterObject['type'].indexOf('.') + 1,
                cmsTypeLenght
              )
              nestedParameterObject['cmsType'] = cmsType
              //console.log(nestedParameterObject)
            }
            nestedParameterObject['parentNodeId'] = serviceObject['id']
            nestedParameterObject['rootNodeId'] = -1 //TODO: can this be referenced at all?

            configNodesMap[nestedParameterObject['id']] = nestedParameterObject

            //push parameter into module children
            if (serviceObject['name'] != 'PrescaleService')
              //Prescales will open in separate table
              serviceObject['children'].push(nestedParameterObject)
            else serviceObject['childrenIds'].push(nestedParameterObject['id'])
          }
        } else if (key1 === 'ctype') {
          serviceObject['ctype'] = value1 as string
        } else if (key1 === 'pytype') {
          serviceObject['pytype'] = value1
        }
      }
      servicesObject['children'].push(serviceObject)

      configNodesMap[serviceObject['id']] = serviceObject
    }

    configNodesMap[servicesObject['id']] = servicesObject

    return { servicesId: servicesObject['id'], idCounter: idCounter }
  },

  parseStreams(
    streamsData: any,
    configNodesMap: Object,
    topLevelStreamNameToIdMap: Object,
    topLevelNodeTypeToIdMap: Object,
    topLevelDataSetsNameReferenceIDsMap: Object,
    topLevelStreamNameReferenceIDsMap: Object,
    idCounter: number,
    nodeCounters: Object
  ) {
    //console.log(streamsData)
    let streamsObject: Object = {
      id: ++idCounter,
      name: 'Streams',
      type: 'streams',
      children: [],
      parentNodeId: 0,
      rootNodeId: idCounter,
    }
    topLevelNodeTypeToIdMap['streams'] = []

    //let psetsIdCounter = this.idCounter

    for (const [key, value] of Object.entries(streamsData)) {
      //loop over psets - create new PSet object and add it to children of the psets
      //console.log('KEY: ' + key)
      //console.log('VALUE: ' + JSON.stringify(value))

      let streamObject: Object = {
        id: ++idCounter,
        name: key,
        type: 'stream',
        children: [],
        parentNodeId: streamsObject['id'],
        rootNodeId: idCounter,
      }
      //console.log('STREAM NAME:' + streamObject['name'])
      topLevelStreamNameToIdMap[streamObject['name']] = streamObject['id']
      topLevelNodeTypeToIdMap['streams'].push(streamObject['id'])

      if (topLevelStreamNameReferenceIDsMap[streamObject['name']] == undefined)
        topLevelStreamNameReferenceIDsMap[streamObject['name']] = new Set()

      let nestedStreamObject: Object = {}
      nestedStreamObject['id'] = ++idCounter

      // eslint-disable-next-line no-unused-vars
      for (let [key2, value2] of Object.entries(Object(value))) {
        //aviod para_name level
        //console.log('ANYTHING')
        //console.log(`${key2}, ${value2}`)
        if (key2 === 'type') nestedStreamObject['type'] = value2 as string
        else if (key2 === 'value') {
          if (
            //I'm not sure this is possible at all
            nestedStreamObject['type'] == 'cms.VPSet' ||
            nestedStreamObject['type'] == 'cms.PSet' ||
            nestedStreamObject['type'] == 'cms.untracked.PSet' ||
            nestedStreamObject['type'] == 'cms.untracked.VPSet'
          ) {
            nestedStreamObject['name'] = key2
            nestedStreamObject['children'] = []

            idCounter = this.buildRecursiveVPSetObject(
              nestedStreamObject,
              value2,
              streamObject['id'],
              configNodesMap,
              idCounter,
              nodeCounters
            )
          } else {
            if (nestedStreamObject['type'] != 'cms.vstring') {
              nestedStreamObject['paremeterJSONValue'] = value2
              nestedStreamObject['children'] = []
              nestedStreamObject['name'] = key2 + ' = '
            } else {
              nestedStreamObject['children'] = []
              nestedStreamObject['rootNodeId'] = -1 //for the leaf nodes, rootNodeId will be calculated with references
              for (let [key3, value3] of Object.entries(Object(value2))) {
                //dummy vstring nodes
                let nestedVStringObject: Object = {}
                nestedVStringObject['id'] = ++idCounter
                nestedVStringObject['name'] = ''
                nestedVStringObject['type'] = 'cms.string'
                nestedVStringObject['paremeterJSONValue'] = value3
                nestedStreamObject['children'].push(nestedVStringObject)

                let dataSetName = value3 as string
                if (
                  topLevelDataSetsNameReferenceIDsMap[dataSetName] == undefined
                ) {
                  topLevelDataSetsNameReferenceIDsMap[dataSetName] = new Set()
                }
                topLevelDataSetsNameReferenceIDsMap[dataSetName].add(
                  nestedVStringObject['id']
                )

                configNodesMap[nestedVStringObject['id']] = nestedVStringObject
              }
              nestedStreamObject['name'] = 'datasets'
            }
          }
        }
      }

      if (nestedStreamObject['type'] != undefined) {
        if (nestedStreamObject['type'] != 'cms.vstring') {
          let cmsTypeLenght = nestedStreamObject['type'].length
          let cmsType = nestedStreamObject['type'].substring(
            //cmsType is necessary for printing out in tree
            nestedStreamObject['type'].indexOf('.') + 1,
            cmsTypeLenght
          )
          nestedStreamObject['cmsType'] = cmsType
        }
        nestedStreamObject['parentNodeId'] = streamObject['id'] //TODO: who's parent?

        configNodesMap[nestedStreamObject['id']] = nestedStreamObject
        streamObject['children'].push(nestedStreamObject)
      }
      streamsObject['children'].push(streamObject)

      configNodesMap[streamObject['id']] = streamObject
    }
    configNodesMap[streamsObject['id']] = streamsObject

    return { streamsId: streamsObject['id'], idCounter: idCounter }
  },

  parseDatasets(
    datasetsData: any,
    configNodesMap: Object,
    topLevelDatasetNameToIdMap: Object,
    topLevelNodeTypeToIdMap: Object,
    topLevelNodeNameReferenceIDsMap: Object,
    topLevelDataSetsNameReferenceIDsMap: Object,
    idCounter: number,
    nodeCounters: Object
  ) {
    //console.log(datasetsData)
    let datasetsObject: Object = {
      id: ++idCounter,
      name: 'Datasets',
      type: 'datasets',
      children: [],
      parentNodeId: 0,
      rootNodeId: idCounter,
    }
    //topLevelNodeNameToIdMap['datasets'] = datasetsObject['id']
    topLevelNodeTypeToIdMap['datasets'] = []

    //let psetsIdCounter = this.idCounter

    for (const [key, value] of Object.entries(datasetsData)) {
      //loop over psets - create new PSet object and add it to children of the psets
      //console.log('KEY: ' + key)
      //console.log('VALUE: ' + JSON.stringify(value))

      let datasetObject: Object = {
        id: ++idCounter,
        name: key,
        type: 'dataset',
        children: [],
        parentNodeId: datasetsObject['id'],
        rootNodeId: idCounter,
      }
      if (
        topLevelDataSetsNameReferenceIDsMap[datasetObject['name']] == undefined
      )
        topLevelDataSetsNameReferenceIDsMap[datasetObject['name']] = new Set()

      topLevelDatasetNameToIdMap[datasetObject['name']] = datasetObject['id']
      topLevelNodeTypeToIdMap['datasets'].push(datasetObject['id'])

      let nestedDatasetObject: Object = {}
      nestedDatasetObject['id'] = ++idCounter

      // eslint-disable-next-line no-unused-vars
      for (let [key2, value2] of Object.entries(Object(value))) {
        //aviod para_name level
        //console.log('ANYTHING')
        //console.log(`${key2}, ${value2}`)
        if (key2 === 'type') nestedDatasetObject['type'] = value2 as string
        else if (key2 === 'value') {
          if (
            //I'm not sure this is possible at all
            nestedDatasetObject['type'] == 'cms.VPSet' ||
            nestedDatasetObject['type'] == 'cms.PSet' ||
            nestedDatasetObject['type'] == 'cms.untracked.PSet' ||
            nestedDatasetObject['type'] == 'cms.untracked.VPSet'
          ) {
            nestedDatasetObject['name'] = key2
            nestedDatasetObject['children'] = []

            idCounter = this.buildRecursiveVPSetObject(
              nestedDatasetObject,
              value2,
              datasetObject['id'],
              configNodesMap,
              idCounter,
              nodeCounters
            )
          } else {
            /*     if (datasetObject.name == 'ExpressPhysics')
              console.log('TYPE: ' + nestedDatasetObject['type']) */
            if (nestedDatasetObject['type'] != 'cms.vstring') {
              nestedDatasetObject['paremeterJSONValue'] = value2
              nestedDatasetObject['children'] = []
              nestedDatasetObject['name'] = key2 + ' = '
            } else {
              nestedDatasetObject['children'] = []
              nestedDatasetObject['rootNodeId'] = -1 //for the leaf nodes, rootNodeId will be calculated with references
              for (let [key3, value3] of Object.entries(Object(value2))) {
                //dummy vstring nodes
                let nestedVStringObject: Object = {}
                nestedVStringObject['id'] = ++idCounter
                nestedVStringObject['name'] = ''
                nestedVStringObject['type'] = 'cms.string'
                nestedVStringObject['paremeterJSONValue'] = value3
                nestedDatasetObject['children'].push(nestedVStringObject)

                let pathName = value3 as string
                if (topLevelNodeNameReferenceIDsMap[pathName] == undefined) {
                  topLevelNodeNameReferenceIDsMap[pathName] = new Set()
                }
                topLevelNodeNameReferenceIDsMap[pathName].add(
                  nestedVStringObject['id']
                )

                configNodesMap[nestedVStringObject['id']] = nestedVStringObject
              }
              nestedDatasetObject['name'] = 'paths'
            }
          }
        }
      }

      if (nestedDatasetObject['type'] != undefined) {
        if (nestedDatasetObject['type'] != 'cms.vstring') {
          let cmsTypeLenght = nestedDatasetObject['type'].length
          let cmsType = nestedDatasetObject['type'].substring(
            //cmsType is necessary for printing out in tree
            nestedDatasetObject['type'].indexOf('.') + 1,
            cmsTypeLenght
          )

          nestedDatasetObject['cmsType'] = cmsType
        }
        nestedDatasetObject['parentNodeId'] = datasetObject['id'] //TODO: who's parent?
        nestedDatasetObject['iconColor'] = ''

        configNodesMap[nestedDatasetObject['id']] = nestedDatasetObject
        datasetObject['children'].push(nestedDatasetObject)
      }
      datasetsObject['children'].push(datasetObject)

      configNodesMap[datasetObject['id']] = datasetObject
    }
    configNodesMap[datasetsObject['id']] = datasetsObject

    return { datasetsId: datasetsObject['id'], idCounter: idCounter }
  },
}
